
import Navbar from "./Navbar";
import { Outlet } from "react-router-dom";
import { useTheme } from "@/components/theme/ThemeProvider";

export default function Layout() {
  const { theme } = useTheme();
  
  return (
    <div className={`min-h-screen bg-background font-serif text-foreground relative ${theme}`}>
      {/* Much more subtle grain texture overlay */}
      <div className="grain-overlay"></div>
      
      <Navbar />
      <main className="relative z-[1] w-full">
        <Outlet />
      </main>
      <footer className="border-t border-border/40 py-6 relative z-[1]">
        <div className="container text-center text-sm text-muted-foreground">
          {new Date().getFullYear()} PierreFT. All rights reserved.
        </div>
      </footer>
    </div>
  );
}
